import { RouteInfo } from './vertical-menu.metadata';
import { AuthUserService } from '../services/userServices/auth-user.service';
import { Injectable } from '@angular/core';

//Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [
  {
    path: '/page/dashboard', title: 'الرئيسية', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  },
  {
    path: '/users-mangament/claims', title: 'ادارة المستخدمين', icon: 'ft-layers', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [
      
    ]
  },
  {
    path: '/page/requests', title: 'الطلبات', icon: 'ft-layers', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  },
];

@Injectable({
  providedIn: 'root',
})
export class GetRoutes{
  constructor(private authUserService:AuthUserService) {
  }
  Routes():RouteInfo[]{
     return [
      {
        path: '/page/dashboard', title: 'الرئيسية', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
      },
    //   {
    //     path: '', title: 'ادارة الفواتير', icon: 'ft-align-left', class: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false,
    //     submenu: [
    //         { path: '/page/bills', title: 'عرض الفواتير', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
    //         { path: '/page/add-bill', title: 'اضافة فاتورة', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
           
    //     ]
    // },
      // {
      //   path: '/page/bills', title: 'الفواتير', icon: 'ft-layers', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
      // },
         {
          path: '', title: 'ادارة المحتوي ', icon: 'ft-align-left', class: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false,
          submenu: [
              { path: '/store/Section', title: 'الاجزاء ', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
              { path: '/store/Content', title: 'المحتوي', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
             
          ]
      },
      {
        path: '/store/EvaluationRate', title: 'التقيمات ', icon: 'ft-align-left', class: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
      //   {
      //     path: '', title: 'ادارة المستخدمين', icon: 'ft-align-left', class: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false,
      //     submenu: [
      //         { path: '/users-mangament/claims', title: 'الصلاحيات', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
      //         { path: '/users-mangament/groups', title: 'المجموعات', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
      //         { path: '/users-mangament/users', title: 'المستخدمين', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
      //     ]
      // },
      // {
      //   path: '/page/requests', title: 'الطلبات', icon: 'ft-layers', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
      // },
      ];
  }
  
  HRoutes(){
     return [
      {
        path: '/page/dashboard', title: 'الرئيسية', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
      },
      {
        path: '/page/requests', title: 'الطلبات', icon: 'ft-layers', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
      },
      ];
  }
}
